import toast from '@kk/toast';
import { computed } from 'vue';
import { useStore } from '@/store';
import { clockOn } from '@/api/clockOn';
import { debounce } from '@kk/utils';
import { useUpadeMainPageData } from '@/hooks/useUpadeMainPageData';
import { useTrack } from '@/hooks/useTrack';
/**
 * 
 * @returns 
 */
export function useClockOn () {
  const store = useStore();
  const clockOnCanObtain = computed(() => store.state.rule.clockOnCanObtain);
  const { trackBtn } = useTrack();
  async function clockOnFn (btnName?: string) {

    try {
      trackBtn(btnName || '打卡');
      const { code, message } = await clockOn();
      if (code === 200) {
        toast.show({
          text: `打卡成功，KK币+${clockOnCanObtain.value}`,
        });
        useUpadeMainPageData();
      } else {
        toast.show({
          text: message || '打卡失败',
        });
      }
    } catch (error) {
      console.log(error);
      toast.show({
        text: (error as Error).message || '打卡失败',
      });
    }
  }
  const debounceClockOn = debounce(clockOnFn, 500);
  return { debounceClockOn, clockOnCanObtain };
}
